<script setup lang="ts">
import HouseForm from "./HouseForm.vue";
import { useUpdateHouse } from "./housesCrud";
import type { House } from "./types";

defineProps<{
  house: House;
}>();

const { updateHouse, updateHouseStatus } = useUpdateHouse();
</script>
<template>
  <section class="box">
    <h2>Allgemeine Adressdaten</h2>
    <HouseForm
      v-if="house !== undefined"
      :house="house"
      :update-house-status="updateHouseStatus"
      @update="updateHouse"
    />
  </section>
</template>
